/**
 * HeaderName.tsx — logo/produktnavn i header (venstre)
 *
 * Ren React-komponent som erstatter cds-header-name.
 * Viser et prefiks (f.eks. "NEVRAL") og et produktnavn.
 *
 * Props:
 * - href: lenke (vanligvis "/")
 * - prefix: kort prefiks (f.eks. bedriftsnavn)
 * - prefixImageSrc / prefixImageAlt: logo-bilde i prefiks-boksen (erstatter prefiks-teksten)
 * - children: produktnavn
 */

import Link from 'next/link';
import styles from './header-name.module.css';

interface HeaderNameProps {
  href?: string;
  prefix?: string;
  prefixImageSrc?: string;
  prefixImageAlt?: string;
  children: React.ReactNode;
}

export default function HeaderName({
  href = '/',
  prefix,
  prefixImageSrc,
  prefixImageAlt = '',
  children,
}: HeaderNameProps) {
  return (
    <Link href={href} className={styles.name}>
      {prefixImageSrc ? (
        <span className={styles.prefix}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={prefixImageSrc} alt={prefixImageAlt} className={styles.prefixLogo} />
        </span>
      ) : (
        prefix && <span className={styles.prefix}>{prefix}</span>
      )}
      {children}
    </Link>
  );
}
